import React from 'react';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

//This components hosts the routes.
import GridSystem from './Grid.js';
import GridSystemSIUnits from './SIUnits/Grid.js'
import AaTabs from './AaTabs.js';

import AAMCReqGrid from './Physics/AAMCReq/AAMCReqGrid.js'

//Physics formulas
import TranslationalMotionGrid from './Physics/TranslationalMotion/TranslationalMotionGrid.js'
import ForceGrid from './Physics/Force/ForceGrid.js'
import WorkGrid from './Physics/Work/WorkGrid.js'
import EnergyGrid from './Physics/Energy/EnergyGrid.js'
import PeriodicMotionGrid from './Physics/PeriodicMotion/PeriodicMotionGrid.js'
import FluidsGrid from './Physics/Fluids/FluidsGrid.js'
import ThermodynamicsGrid from './Physics/Thermodynamics/ThermodynamicsGrid.js'
import ElectrostaticsGrid from './Physics/Electrostatics/ElectrostaticsGrid.js'
import CircuitsGrid from './Physics/Circuits/CircuitsGrid.js'
import MagnetismGrid from './Physics/Magnetism/MagnetismGrid.js'
import SoundGrid from './Physics/Sound/SoundGrid.js'
import LightGrid from './Physics/Light/LightGrid.js'
import OpticsGrid from './Physics/Optics/OpticsGrid.js'
import AtomicNucleusGrid from './Physics/AtomicNucleus/AtomicNucleusGrid.js'


class App extends React.Component {

  render() {
    return (
      <Router>
        <div>

          <Route exact path = "/" component = {GridSystem} />
          <Route exact path = "/SIUnits" component = {GridSystemSIUnits} />

          {
            //The physics tab
          }
          <Route exact path = "/physics" component = {AAMCReqGrid} />
          {
            //The physics formula tabs
          }
          <Route exact path = "/physics/translationalmotion" component = {TranslationalMotionGrid} />
          <Route exact path = "/physics/force" component = {ForceGrid} />
          <Route exact path = "/physics/work" component = {WorkGrid} />
          <Route exact path = "/physics/energy" component = {EnergyGrid} />
          <Route exact path = "/physics/periodicmotion" component = {PeriodicMotionGrid} />
          <Route exact path = "/physics/fluids" component = {FluidsGrid} />
          <Route exact path = "/physics/thermodynamics" component = {ThermodynamicsGrid} />
          <Route exact path = "/physics/electrostatics" component = {ElectrostaticsGrid} />
          <Route exact path = "/physics/circuits" component = {CircuitsGrid} />
          <Route exact path = "/physics/magnetism" component = {MagnetismGrid} />
          <Route exact path = "/physics/sound" component = {SoundGrid} />
          <Route exact path = "/physics/light" component = {LightGrid} />
          <Route exact path = "/physics/optics" component = {OpticsGrid} />
          <Route exact path = "/physics/atomicnucleus" component = {AtomicNucleusGrid} />

        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js